<template>
    <div class="mt-1">
        <b-row>
            <b-col md="6" lg="6">
                <InformationRequested :request="request" />
            </b-col>
            <b-col md="6" lg="6">
                <Conversation
                    :request-id="request.id"
                    :height="230"
                    class-name="border-gray"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import {Conversation} from "@core/components/messenger";
import InformationRequested from "@/views/request/received/flow/components/vertiacal-steps/InformationRequested.vue";
import { BRow, BCol, BCard, BCardTitle, BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
    components: {
        BRow, BCol, BCard, BCardTitle, BListGroup, BListGroupItem, Conversation, InformationRequested,
    },
    props: {
        request: {
            type: Object,
            default() {
                return {
                    id: null,
                    product: {
                        identifiers: []
                    }
                };
            }
        },
    },
}
</script>
